class GalleryFixedTitle {
	constructor(sel) {
		// view
		this.component = document.querySelector(sel);
		this.sel = sel;
		this.header = this.component.querySelector('.header');

		if (this.component) {
			this.init();
		}
	}
	viewHeightToPx = (vh) => (vh / 100) * WH;
	get isMobile() {
		return window.innerWidth < 960;
	}
	init() {
		const titleFadeOut = gsap.to(`${this.sel} .header`, {
			onStart: () => {
				this.header.classList.toggle('soft-hide', true);
			},
			onReverseComplete: () => {
				this.header.classList.toggle('soft-hide', false);
			},
			leaveBack: () => {
				this.header.classList.toggle('soft-hide', false);
			},
			scrollTrigger: {
				trigger: `${this.sel} .images`,
				start: `top+=${this.viewHeightToPx(
					this.isMobile ? 30 : 40
				)}px bottom`,
				end: `top+=${this.viewHeightToPx(
					this.isMobile ? 50 : 80
				)}px bottom`,
				scrub: 0.5
			},
		});

		const titleFadeIn = gsap.to(`${this.sel} .header`, {
			onStart: () => {
				this.header.classList.toggle('soft-hide', false);
			},
			onReverseComplete: () => {
				this.header.classList.toggle('soft-hide', true);
			},
			scrollTrigger: {
				trigger: `${this.sel} .images`,
				start: `bottom-=${this.viewHeightToPx(
					this.isMobile ? 10 : 60
				)} top`,
				endTrigger: this.sel,
				end: 'bottom bottom',
				scrub: 0.5,
			},
		});
	}
}

document.addEventListener('DOMContentLoaded', function () {
	const galleryFixedTitle = new GalleryFixedTitle('.gallery-fixed-title');
});
